import React from 'react'
import type SvgIcon from 'LuxKit/SvgIcon'
import SolidTicketIcon from 'LuxKit/Icons/solid/SolidTicketIcon'

/**
 * Maps icon string names to icon components for ContentTags
 */
const iconMap: Record<string, typeof SvgIcon> = {
  ticket: SolidTicketIcon,
}

/**
 * Gets the icon component for a given icon name
 * @param iconName - The icon name from ContentTag fields
 * @returns The icon component as a React element, or undefined if not found
 */
export function getContentTagIcon(iconName: string | undefined): React.ReactElement | undefined {
  if (!iconName) {
    return undefined
  }

  const Icon = iconMap[iconName]
  if (!Icon) {
    return undefined
  }

  return React.createElement(Icon)
}
